
// src/web/components/rich-text-editor.js

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import ReactDOM from 'react-dom'
import { PropTypes } from 'prop-types'
import config from '../../config'
import classnames from 'classnames'
import Squire from 'squire-rte'
import _ from 'lodash'
import ui from '../../helpers/ui-state'
import { translate } from 'react-i18next'
import { themr } from 'react-css-themr'
import context from '../../helpers/context'
import { track } from '../../helpers/analytics'
import { encodeEmojiTag, convertEmojiHTML } from '../../helpers/emoji-helpers'
import sanitizeHTML from '../../helpers/sanitize-html'
import isGoogleDocUrl from '../../helpers/google-doc'
import isGambaUrl from '../../helpers/gamba-url'
import { urlRegex } from '../../helpers/url-regexp'
import {
  Navigation,
} from 'react-toolbox/lib/navigation'
import {
  Button
} from 'react-toolbox/lib/button'
import TemplateSelectionDialog from './rich-text-editor-template-selection-dialog.jsx'
import toolbarTheme from './themes/rich-text-editor-toolbar-navigation.css'
import richTextEditorTheme from './themes/rich-text-editor.css'
import successButtonTheme from './themes/success-button.css'
import SquireHTML from './rich-text-editor-iframe-html'
import animation from './animation-css'
import parseAttributes from '../../helpers/parse-attributes'
import purgeHtml from '../../helpers/purge-html'
import ConfirmDialog from './confirm-dialog.jsx'

const UrlRegex = urlRegex()
const DEFAULT_HEIGHT_TEXT_EDITOR = 88

function toggleFormat(format, editor) {
  switch(format) {
  case 'bold':
    if (editor.hasFormat('B'))
      editor.removeAllFormatting()
    else
      editor.bold()
    break

  case 'italic':
    if (editor.hasFormat('I'))
      editor.removeAllFormatting()
    else
      editor.italic()
    break

  case 'underline':
    if (editor.hasFormat('U'))
      editor.removeAllFormatting()
    else
      editor.underline()
    break

  case 'redText':
    if (editor.hasFormat('SPAN', { style: "color:rgb(255,0,0)" }))
      editor.removeAllFormatting()
    else
      editor.setTextColour('rgb(255,0,0)')
    break

  case 'highlightText':
    if (editor.hasFormat('SPAN', { style: "background:rgb(255,255,119)" }) || editor.hasFormat('SPAN', { style: "background-color:rgb(255,255,119)" }))
      editor.removeAllFormatting()
    else
      editor.setHighlightColour('rgb(255,255,119)')
    break

  case 'unorderedList':
    if (editor.hasFormat('UL'))
      editor.removeList()
    else
      editor.makeUnorderedList()
    break

  case 'orderedList':
    if (editor.hasFormat('OL'))
      editor.removeList()
    else
      editor.makeOrderedList()
    break
  }
}

function selectTemplate(template_id) {
  var templateHistory = JSON.parse(localStorage.getItem('gambaApp.templateHistory') || '[]')
  var index = _.findIndex(templateHistory, (item)=> { return item.template_id == template_id })
  if (index >= 0)
    templateHistory.splice(index, 1)
  templateHistory.unshift({ template_id, used_at: (new Date()).getTime() })
  localStorage.setItem('gambaApp.templateHistory', JSON.stringify(templateHistory))
}

function sortTemplates(templates) {
  var templateHistory = JSON.parse(localStorage.getItem('gambaApp.templateHistory') || '[]')
  var sortedTemplates = _.sortBy(_.map(templates, (template)=> {
    var history = _.find(templateHistory, (item)=> { return item.template_id == template.template_id })
    if (history)
      return Object.assign({}, template, { used_at: history.used_at })
    else
      return Object.assign({}, template, { used_at: 0 })
  }), ['used_at']).reverse()
  return sortedTemplates
}

@themr('RichTextEditor', richTextEditorTheme)
class RichTextEditor extends PureComponent {
  state = {}

  constructor(props) {
    super(props)

    if (!this.props.noToolbar) {
      if (!this.props.compact) {
        this.actions = [
          { icon: 'format_bold', onClick: ()=> toggleFormat('bold', this.props.ui.editor), style: { color: 'white' } },
          { icon: 'format_underline', onClick: ()=> toggleFormat('underline', this.props.ui.editor), style: { color: 'white' } },
          { icon: 'format_italic', onClick: ()=> toggleFormat('italic', this.props.ui.editor), style: { color: 'white' } },
          { icon: 'format_color_text', onClick: ()=> toggleFormat('redText', this.props.ui.editor) , style: { color: 'red' }},
          { icon: 'format_color_text', onClick: ()=> toggleFormat('highlightText', this.props.ui.editor) , style: { color: '#FF0' }},
          { icon: 'format_list_bulleted', onClick: ()=> toggleFormat('unorderedList', this.props.ui.editor), style: { color: 'white' } },
          { icon: 'format_list_numbered', onClick: ()=> toggleFormat('orderedList', this.props.ui.editor), style: { color: 'white' } },
          { icon: 'check_box', onClick: this.insertCheckbox, style: { color: 'white' } },
          { icon: 'sentiment_satisfied', onClick: ()=> this.props.showEmojiPalette(this.insertEmoji), style: { color: 'white' } }
        ]
      }
      else
        this.actions = [
          { icon: 'format_bold', onClick: ()=> toggleFormat('bold', this.props.ui.editor), style: { color: 'white' } },
          { icon: 'format_bold', onClick: ()=> toggleFormat('redText', this.props.ui.editor) , style: { color: 'red' }},
          { icon: 'format_color_text', onClick: ()=> toggleFormat('highlightText', this.props.ui.editor) , style: { color: '#FF0' }},
          { icon: 'sentiment_satisfied', onClick: ()=> this.props.showEmojiPalette(this.insertEmoji), style: { color: 'white' } }
        ]
      if (this.props.templates)
        this.actions.push({ label: this.props.t('label:テンプレート'), onClick: ()=> props.updateUI({ showTemplateDialog: true }), style: { color: 'white', fontWeight: 'bold', fontSize: 12 } })
      if (this.props.userDescription)
        this.actions.push({ label: this.props.t('label:テンプレート'), onClick: ()=> { props.updateUI({ importConfirm: !this.props.ui.importConfirm }); props.importUserProfileTemplate()}, style: { color: 'white', fontWeight: 'bold', fontSize: 12 }  })
    }
  }

  insertEmoji = (shortname, unicode)=> {
    if(this.props.ui.editor) {
      this.props.ui.editor.insertImage(
        `${config.emojiPNG}${unicode}.png`,
        { style: "width: 18px; height: 18px;" }
      )
    }
  }

  getValue = (callback, no_strip = false)=> {
    // Return if Editor is not initialized or getHTML is not a function
    if (!this.props.ui || !this.props.ui.editor || typeof this.props.ui.editor.getHTML !== 'function') {
      return;
    }
    var html = encodeEmojiTag(this.props.ui.editor.getHTML()).replace(/&nbsp;/g, ' ')
      .replace(/class="colour"/g, '')
      .replace(/class="highlight"/g, '')
      .replace(/<a([^>]*)>.*?<\/a>/g, (match, attr)=> {
        var attrs = parseAttributes(attr.trim())
        var href = attrs && attrs['href'] || ''
        return href.replace(/^mailto:/, '') + ' '
      })
      .replace(/<input[^>]*>/g, (tag)=> {
        // HTML中にinputタグがあった場合valueを正しく設定する
        var attrs = parseAttributes(tag.slice('<input'.length, tag.length - 1).trim())
        const element = this.props.ui.body.ownerDocument.getElementById(attrs['id'])
        delete attrs['contenteditable'];
        if (element) {
          if (element.type == 'checkbox') {
            delete attrs['value']
            delete attrs['checked']
            attrs['disabled'] = 'true'
            if (element.checked) attrs['checked'] = 'true'
          }
          delete attrs['id']
          return `<input ${_.map(attrs, (val, key)=> `${key}="${val}"`).join(' ')}>`
        } else
          return ''
      })
      .replace(/<span contenteditable="false">(<input[^>]*>)<\/span>/g, '$1')

    if (!no_strip)
      html = html.replace(/^(<(div|p)>(<br\/?>)?<\/(div|p)>)+/, '').replace(/(<(div|p)>(<br\/?>)?<\/(div|p)>)+$/, '')

    if (html.length > 0 && !html.match(/^<.*>$/i))
      html = '<div>' + html + '</div>'

    callback && callback(html)
  }

  clearValue  = ()=> {
    this.props.ui.editor.setHTML('')
    this.props.ui.editor.blur()
    this.props.updateUI({ focus: false })
    this.resetIframe()
  }

  insertValue = (html, silent = false, reset = false)=> {
    this.props.ui.editor && this.props.ui.editor[reset ? 'setHTML' : 'insertHTML'](
      purgeHtml(
        convertEmojiHTML(html.replace(UrlRegex, (match=> {
          this.props.onAddLink && this.props.onAddLink(match)
          return (
            this.props.showGoogleDoc && isGoogleDocUrl(match) && `<a contenteditable=false target="_blank" rel="noopener noreferrer" class="googleDoc" href="${match}">${this.props.t('label:Googleドキュメント')}</a>` ||
            this.props.showGambaUrl && isGambaUrl(match) && `<a contenteditable=false href="${match}" target="_blank" rel="noopener noreferrer" class="gambaUrl">${this.props.t('label:gambaで開く')}</a>` ||
            `<a contenteditable=false target="_blank" rel="noopener noreferrer" href="${match.match(/^http/i) ? match : 'http://' + match }">${(match.length > 80 ? match.slice(0, 30)+'...'+match.slice(match.length-20, match.length) : match)}</a>`
          )
        })))
      ))
    if (this.refs.iframe) {
      const scrollHeight = this.props.ui.body && this.props.ui.body.scrollHeight || DEFAULT_HEIGHT_TEXT_EDITOR
      ReactDOM.findDOMNode(this.refs.iframe).style.height = scrollHeight + 5 + 'px'
    }
    this.setGoogleDocHrefHandler()
    this.setGabmaHrefHandler()
    this.props.updateUI({ focus: true })
    this.props.onFocus && this.props.onFocus()
  }

  setGoogleDocHrefHandler = ()=> {
    if (!this.props.showGoogleDoc || !this.props.ui.body) return
    _.each(
      ReactDOM.findDOMNode(this.props.ui.body).getElementsByClassName('googleDoc'),
      (element)=> {
        if (element.onclick) return
        element.onclick = (event)=> {
          event.preventDefault()
          this.props.showGoogleDoc(element.href)
        }
      }
    )
  }

  setGabmaHrefHandler = ()=> {
    if (!this.props.showGambaUrl || !this.props.ui.body) return
    _.each(
      ReactDOM.findDOMNode(this.props.ui.body).getElementsByClassName('gambaUrl'),
      (element)=> {
        if (element.onclick) return
        element.onclick = (event)=> {
          event.preventDefault()
          this.props.showGambaUrl(element.href)
        }
      }
    )
  }

  setFocus = ()=> {
    this.props.ui.editor.focus()
    this.props.updateUI({ focus: true })
    this.props.onFocus && this.props.onFocus()
  }

  onDrop = (e)=> {
    e.preventDefault && e.preventDefault()
    this.props.updateUI({ dragEnter: false })
    this.props.onDrop && this.props.onDrop(e.dataTransfer.files)
    return false
  }
  onDragEnter = ()=> this.props.updateUI({ dragEnter: true })
  onDragLeave = ()=> this.props.updateUI({ dragEnter: false })

  onLoadIframe = ()=> {
    var iframe = ReactDOM.findDOMNode(this.refs.iframe)
    this.initSquireEditor(iframe.contentWindow.document)
    var body = iframe.contentWindow.document.getElementsByTagName('body')[0]
    body.ondragenter = ()=> this.props.updateUI({ dragEnter: true })
    body.ondragleave = ()=> this.props.updateUI({ dragEnter: false })
    body.ondrop = this.onDrop
    body.onclick = ()=> {
      if (!this.props.ui.focus) {
        this.props.updateUI({ focus: true })
        this.props.onFocus && this.props.onFocus()
      }
    }
  }

  initIframe = ()=> {
    if (this.refs.iframe) {
      ReactDOM.findDOMNode(this.refs.iframe).style.height = '100px'
      var idoc = ReactDOM.findDOMNode(this.refs.iframe).contentWindow.document
      idoc.open()
      idoc.write(SquireHTML)
      idoc.close()
    }
  }

  resetIframe = ()=> {
    if (this.refs.iframe) {
      ReactDOM.findDOMNode(this.refs.iframe).style.height = '100px'
    }
  }

  initSquireEditor = (doc)=> {
    let maxScrollHeight = DEFAULT_HEIGHT_TEXT_EDITOR;
    var editor = new Squire(doc, {
      sanitizeToDOMFragment: sanitizeHTML,
      tagAttributes: {
        a: { contenteditable: false, target: '_blank', rel: "noopener noreferrer"  }
      }
    })
    this.props.updateUI({ editor, body: doc.getElementsByTagName('body') && doc.getElementsByTagName('body')[0] || doc })

    editor.addEventListener('focus', ()=> {
      this.props.updateUI({ focus: true })
      this.props.onFocus && this.props.onFocus()
    })
    editor.addEventListener('input', ()=> {
      if (this.refs.iframe) {
        const iframe = ReactDOM.findDOMNode(this.refs.iframe);
        const currentScrollHeight = this.props.ui.body && this.props.ui.body.scrollHeight || DEFAULT_HEIGHT_TEXT_EDITOR;
        const iframeDoc = iframe.contentWindow.document;
        
        // Update maxScrollHeight if the current is larger
        if (currentScrollHeight > maxScrollHeight) {
          maxScrollHeight = currentScrollHeight;
        }

        iframe.style.height = maxScrollHeight + 5 + 'px';
        if (iframeDoc) {
          if (maxScrollHeight > 300) {
            iframeDoc.body.style.overflowY = "auto";
          } else {
            iframeDoc.body.style.overflowY = "hidden";
          }
        }
      }
      this.props.onChange && this.props.onChange()
    })
    editor.addEventListener('addLink', (event)=> this.props.onAddLink(event.link))
    editor.addEventListener('paste', (event)=> {
      const text = (event.clipboardData || window.clipboardData).getData('text')
      if (text) text.replace(UrlRegex, (_match)=> this.props.onAddLink(_match))
    })

    this.props.hasFocus && editor.focus()
    this.props.onEditorInitialized && this.props.onEditorInitialized({
      getValue:    this.getValue,
      clearValue:  this.clearValue,
      insertValue: this.insertValue,
    })
  }

  showTemplateDialog = ()=> {
    this.props.updateUI({ showTemplateDialog: true })
    track('show_templates')
  }

  importDialog = () => this.props.updateUI({ importConfirm: !this.props.ui.importConfirm })

  importUserProfileTemplate = () =>{
    this.props.updateUI({ importConfirm: !this.props.ui.importConfirm })
    this.props.importUserProfileTemplate()
  }

  clearUserProfileTemplate = () => {
    this.props.updateUI({ importConfirm: !this.props.ui.importConfirm })
    this.props.clearUserProfileTemplate()
  }

  insertCheckbox = ()=> {
    this.insertValue(`<input type="checkbox">&#x200B;`)
    this.props.ui.editor.focus()
  }

  hideTemplateDialog = ()=> this.props.updateUI({ showTemplateDialog: false })

  editDialogRef = (c)=> this.editDialog = c
  inputDialogRef = (c)=> this.inputDialog = c

  componentDidMount() {
    this.initIframe()
    this.refs.editor && this.initSquireEditor(ReactDOM.findDOMNode(this.refs.editor))
    if (this.refs.iframe) {
      ReactDOM.findDOMNode(this.refs.iframe).style.height = '100px'
    }
  }

  componentWillUnmount() {
    this.props.ui.editor && delete this.props.ui.editor
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.actions && !this.props.templates && nextProps.templates && !_.some(this.actions, (action)=> action.label == 'テンプレート'))
      this.actions.push({ label: this.props.t('label:テンプレート'), onClick: ()=> nextProps.updateUI({ showTemplateDialog: true }), style: { color: 'white', fontWeight: 'bold', fontSize: 12 } })
  }

  render() {
    const {
      t,
      ui,
      value,
      compact,
      theme,
      templates,
      templateActions,
      noToolbar,
      onFocus,
      onTemplateSelect,
      onEditorInitialized,
      onDrop,
      placeholder,
      updateUI,
      showEmojiPalette,
      blinking,
      editTemplate,
      category,
      chatMessage,
      userDescription,
      importUserProfileTemplate,
      userProfileTemplate,
      clearUserProfileTemplate,
    } = this.props

    return (
      <div onDrop={this.onDrop}
          onDragEnter={this.onDragEnter}
          onDragLeave={this.onDragLeave}
          style={{ position: 'relative' }}>
        {ui.focus && this.actions &&
            <Navigation type='horizontal' theme={toolbarTheme} actions={this.actions} />}
            <iframe ref="iframe" scrolling={chatMessage ? 'auto' : 'no'}
              {...animation(blinking && !ui.focus, {
                from: { borderColor: '#CCC', borderLeftWidth: 1, borderRightWidth: 1 },
                to: { borderColor: '#3399FF', borderLeftWidth: 3, borderRightWidth: 3 },
              })}
              className={classnames(chatMessage ? 'chat_message' : '' , theme.editor, ui.focus && this.actions && theme.withToolbar, ui.dragEnter && theme.dragEntered)}
              onLoad={this.onLoadIframe}
              style={{width: '100%'}}/>
        {!ui.focus && !value && placeholder &&
            <div onClick={this.setFocus}
              style={{
              position: 'absolute',
              top: 0, left: 0,
              padding: '10px',
              color: 'rgba(0,0,0,0.5)',
            }}>
            {placeholder}
            </div>}
        {templates && !ui.focus && !value &&
            <Button raised primary icon='mode_edit'
                {...animation(blinking, {
                  duration: '0.5s',
                  delay: '3s',
                  iterationCount: 2,
                })}
                onClick={this.showTemplateDialog}
                label={t(`diary:${category}を書く`)}
                style={{
                  position: 'absolute',
                  top: 0, bottom: 0, left: 0, right: 0,
                  margin: 'auto',
                  width: '340px'
                }}/>}
        {userDescription && !ui.focus && !value &&
            <Button raised primary icon='mode_edit'
                {...animation(blinking, {
                  duration: '0.5s',
                  delay: '3s',
                  iterationCount: 2,
                })}
                onClick={this.importUserProfileTemplate}
                label={t(`label:プロフィールを登録する`)}
                style={{
                  position: 'absolute',
                  top: 0, bottom: 0, left: 0, right: 0,
                  margin: 'auto',
                  width: '360px'
                }}/>}
        <TemplateSelectionDialog
          active={ui.showTemplateDialog}
          onClose={this.hideTemplateDialog}
          onSelect={(id, name, template, fields)=> {
            selectTemplate(id)
            this.insertValue(template)
            onTemplateSelect && onTemplateSelect(name, fields, id)
          }}
          templates={sortTemplates(templates)}
          actions={templateActions} />
        <ConfirmDialog
          open={ui.importConfirm}
          title={t('label:プロフィールテンプレート')}
          yesLabel={t('label:OK')}
          noLabel={t('label:取り消し')}
          onNo={this.clearUserProfileTemplate}
          onYes={() => {
            updateUI({ importConfirm: !ui.importConfirm })
            userProfileTemplate && this.insertValue(userProfileTemplate.template)
          }}
        />
      </div>
    )
  }
}

export default translate()(ui({
  state: {
    editor: undefined,
    body: undefined,
    focus: (props)=> props.hasFocus,
    dragEnter: false,
    showTemplateDialog: false,
    importConfirm: false,
  }})(context({ showEmojiPalette: PropTypes.func })(RichTextEditor)))



// WEBPACK FOOTER //
// ./src/web/components/rich-text-editor.jsx